var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPinOutline = function SvgLocationPinOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.167A4.08 4.08 0 0 0 2.917 5.25c0 2.249 2.202 5.284 3.372 6.738a.904.904 0 0 0 1.422 0c1.17-1.454 3.372-4.49 3.372-6.738A4.08 4.08 0 0 0 7 1.167M4.083 5.25a2.918 2.918 0 0 1 5.834 0c0 1.68-1.68 4.194-2.917 5.763-1.213-1.557-2.917-4.1-2.917-5.763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.708a1.458 1.458 0 1 0 0-2.916 1.458 1.458 0 0 0 0 2.916"
  })));
};
export default SvgLocationPinOutline;